<template>
    <dd-form-grid-item  v-if="fieldComponent">
      <component
          :is="fieldComponent"
          v-model="model.attributes.value"
          @vehicle="onVehicleDataEmit"
          @postal-code="onAddressDataEmit"
          @house-number="onAddressDataEmit"
          :searchable="true"
          :name="field.attributes.name"
          :title="field.attributes.title"
          :options="field.attributes.options"
          :className="field.attributes.class"
          :data-dusk="field.attributes.dusk"
          v-bind="field.attributes.props"
      />
    </dd-form-grid-item>
</template>

<script>
import RenderableComponentToComponentEnum
  from '../../../new_design_components/enums/RenderableComponentToComponentEnum';
import {mapActions, mapState} from 'vuex';

export default {
  name: "CoverageField",
  props: {
    module: String,
    field: {
      component: {
        type: String,
        required: true,
      },
      catalog_id: Number,
      entity_code: Number,
      index: Number,
      attributes: {
        name: {
          type: String,
        },
        class: {
          type: String,
        },
        value: {
          type: String,
        },
        options: {
          type: Array
        },
        props: {
          type: Object
        },
        title: {
          required: true,
          type: String,
        },
        dusk: {
          required: true,
          type: String,
        }
      },
    },
    viewUuid: {
      type: String,
      required: true,
    },
  },
  created() {
    // This is for setting default values of a renderable input field to the form state.
    if(
        this.model === null
        && this.field?.attributes?.value !== undefined
        && this.field?.attributes?.value !== null
    ) {
      this.model = this.field?.attributes?.value;
    }
  },
  methods: {
    onVehicleDataEmit(vehicleData) {
      this.fillVehicleDataFields(vehicleData)
    },
    onAddressDataEmit() {
      this.suggestAddressDataFields(this.viewUuid)
    },
    ...mapActions(`$_generic_insurance`, {
      fillVehicleDataFields: 'fillVehicleDataFields',
      suggestAddressDataFields: 'suggestAddressDataFields',
      setPolicyGroupKey: 'setPolicyGroupKey',
    }),
  },
  computed: {
    fieldComponent() {
      return RenderableComponentToComponentEnum[this.field.component];
    },
    ...mapState({
      form() {
        return state[this.module].form;
      },
      getPolicyGroupValue() {
        return this.$store.getters[this.module + '/getPolicyGroupValue'];
      }
    }),
    model: {
      get() {
        return this.field;
        // return this.getPolicyGroupValue(this.field);
      },
      set(value) {
        this.$emit('update-field', value)
        // this.setPolicyGroupKey({field: this.field, value: value});
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
